export const PERMISSOES_DEFINIDAS_USUARIO_TITLE = 'Permissões Definidas para o Usuário';
export const RELACAO_ITENS_CONFIGURAVEL_TITLE = 'Relações de Itens Configuráveis';
export const ACOES_CONFIGURAVEIS_SELECIONADO_TITLE = 'Ações Configuráveis para o Item Selecionado';
export const SELECIONAR_TODOS_HINT = 'Selecionar Todas';
